import { CmsResourceTrainingSlugs, WordpressPaging } from '@app/enums/_index';
import { Observable, throwError } from 'rxjs';

import { ErrorHandlerService } from '../shared/error-handler.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StaticPageInterface } from '@app/interfaces/_index';
import { catchError } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { getCacheBustedParams } from '@app/utilities/cacheBustedHttpParams.utilities';

@Injectable({
  providedIn: 'root',
})
export class TrainingSupportElearningPageService extends ErrorHandlerService {
  private staticPagesURL = `${environment.cms.url}/wp-json/wp/v2`;

  constructor(private http: HttpClient) {
    super();
  }

  /**
   * Returns the Training elearning Page response from the wordpress API
   *
   * @param - passes the string slug name
   * @returns - Training elearning Page observable response
   */
  getElearningStatic(slug: string): Observable<StaticPageInterface[]> {
    const serviceName = this.getServiceNameBySlug(slug);
    const eLearninigStaticPageURLParams = getCacheBustedParams()
      .append(WordpressPaging.ORDER_BY_KEY, WordpressPaging.ORDER_BY_VALUE)
      .append(WordpressPaging.ORDER_KEY, WordpressPaging.ORDER_VALUE)
      .append(WordpressPaging.PER_PAGE_KEY, WordpressPaging.PER_PAGE_VALUE);

    return this.http
      .get(`${this.staticPagesURL}/${serviceName}`, { params: eLearninigStaticPageURLParams })
      .pipe(
        catchError((err) => {
          console.log(`Service error has occurred`, err);
          return throwError(() => new Error(err));
        }),
        catchError(this.handleError<StaticPageInterface[]>('getElearningStatic', []))
      );
  }

  /**
   * Returns the static pages from the wordpress API
   *
   * @returns - Static Page observable response
   */
  getStaticPages(): Observable<StaticPageInterface[]> {
    const ContentParams = getCacheBustedParams();
    return this.http.get(`${this.staticPagesURL}/pages`, { params: ContentParams }).pipe(
      catchError((err) => {
        console.log(`Service error has occurred`, err);
        return throwError(() => new Error(err));
      }),
      catchError(this.handleError<StaticPageInterface[]>('staticPagesURL', []))
    );
  }

  /**
   * Get the API name based on the Slug for the specific resource training slug name
   *
   * @param - passes the string slug name
   * @returns - the Service API name that corresponds to the cms resource training slug
   */
  getServiceNameBySlug(slug: string): string {
    let serviceName: string;
    if (slug === CmsResourceTrainingSlugs.GENESYS_CLOUD_ELEARNING) {
      serviceName = CmsResourceTrainingSlugs.GENESYS_CLOUD_ELEARNING_SERVICE_NAME;
    } else if (slug === CmsResourceTrainingSlugs.GENESYS_DX_ELEARNING) {
      serviceName = CmsResourceTrainingSlugs.GENESYS_DX_SERVICE_NAME;
    } else {
      serviceName = slug;
    }
    return serviceName;
  }
}
